import axios from 'axios';
import { API_BASE } from '../config';


const authHeaders = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem('token')}`
  }
});

// گرفتن یک فرم با شناسه
export const getFormById = async (formId) => {
  try {
    const res = await axios.get(`${API_BASE}forms/${formId}`, authHeaders());
    return res.data;
  } catch (err) {
    console.error('❌ خطا در دریافت فرم:', err);
    throw err;
  }
};

// گرفتن پاسخ قبلی کاربر به یک فرم (اختیاری)
export const getMyFormResponse = async (formId, subjectId) => {
  try {
    const res = await axios.get(`${API_BASE}form-responses/${formId}/me`, {
      ...authHeaders(),
      params: subjectId ? { subjectId } : {},
    });
    return res.data;
  } catch (err) {
    if (err.response?.status === 404) return null;
    console.error('❌ خطا در دریافت پاسخ کاربر:', err);
    throw err;
  }
};


// ارسال یا به‌روزرسانی پاسخ به فرم
export const submitFormResponse = async (payload) => {
  try {
    // اگه FormData بود، نباید Content-Type رو خودمون ست کنیم
    const isFormData = payload instanceof FormData;

    const res = await axios.post(`${API_BASE}form-responses`, payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
      },
    });

    return res.data;
  } catch (err) {
    console.error('❌ خطا در ارسال پاسخ:', err);
    throw err;
  }
};


// گرفتن پاسخ‌ها با فیلتر و صفحه‌بندی
export const getAllFormResponses = async (params = {}) => {
  try {
    const res = await axios.get(`${API_BASE}form-responses`, {
      headers: authHeaders().headers,
      params
    });
    return res.data;
  } catch (err) {
    console.error('خطا در دریافت پاسخ‌ها:', err);
    throw err;
  }
};

// ارزیابی یک پاسخ
export const evaluateFormResponse = async (id, data) => {
  try {
    const res = await axios.patch(`${API_BASE}form-responses/${id}/evaluate`, data, authHeaders());
    return res.data;
  } catch (err) {
    console.error('خطا در ارزیابی:', err);
    throw err;
  }
};

export const getFullFormResponse = async (id) => {
  try {
    const res = await axios.get(`${API_BASE}form-responses/${id}/full`, authHeaders());
    return res.data;
  } catch (err) {
    console.error('خطا در دریافت جزئیات پاسخ:', err);
    throw err;
  }
};

export const getFormResponseForEvaluation = async (id) => {
    try {
    const res = await axios.get(`${API_BASE}form-responses/evaluate-view/${id}`, authHeaders());
    // console.log('res', res);
    return res.data;
  } catch (err) {
    console.error('❌ ارزیابی فراخوانی نشد:', err);
    throw err;
  }
};


export const getResponseStatistics = async (filters = {}) => {
  try {
    const res = await axios.get(`${API_BASE}form-responses/statistics`, {
      headers: authHeaders().headers,
      params: filters
    });
    return res.data;
  } catch (err) {
    console.error('خطا در دریافت آمار:', err);
    throw err;
  }
};


export const getFormResponseCounts = async (filters = {}) => {
  try {
    const res = await axios.get(`${API_BASE}form-responses/form-counts`, {
      headers: authHeaders().headers,
      params: filters
    });
    return res.data;
  } catch (err) {
    console.error('خطا در دریافت آمار:', err);
    throw err;
  }
};

export const getDailyResponseTrends = async (filters = {}) => {
  try {
    const res = await axios.get(`${API_BASE}form-responses/daily-trend`, {
      headers: authHeaders().headers,
      params: filters
    });
    return res.data;
  } catch (err) {
    console.error('خطا در دریافت آمار:', err);
    throw err;
  }
};

export const getAverageScoreByForm = async (filters = {}) => {
  try {
    const res = await axios.get(`${API_BASE}form-responses/average-score`, {
      headers: authHeaders().headers,
      params: filters
    });
    return res.data;
  }
  catch (err) {
    console.error('خطا در دریافت آمار:', err);
    throw err;
  }
};

export const getTopFormsAndUsers = async (filters = {}) => {
  try {
    const res = await axios.get(`${API_BASE}form-responses/top`, {
      headers: authHeaders().headers,
      params: filters
    });
    return res.data;
  }
  catch (err) {
    console.error('خطا در دریافت آمار:', err);
    throw err;
  }
};

export const downloadExcelReport = async () => {
  try {
    const res = await axios.get(`${API_BASE}form-responses/download-report`, {
      headers: authHeaders().headers,
      responseType: 'blob'
    });

    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'report.xlsx');
    document.body.appendChild(link);
    link.click();
  } catch (err) {
    console.error(err);
  }
};

export const getFormResponses = async (params = {}) => {
  // params می‌تونه باشه: { subjectId, formId, status, startDate, endDate, page, limit }
  const res = await axios.get(`${API_BASE}form-responses`, {
    ...authHeaders(),
    params,
  });
  return res.data; // { data: [...], totalCount: ... }
};

export const getFormResponsesForCompare = async ({ formId, page = 1, limit = 20 }) => {
  const res = await axios.get(`${API_BASE}form-responses/by-form`, {
    ...authHeaders(),
    params: { formId, page, limit },
  });
  return res.data; // { data, totalCount }
};



